import { Suspense } from "react";
import { GlobalProvider } from "./GlobalContext";
import { Loading } from "./page/elements/Loading";
import Routing from "./Routing";
import "./scss/main.scss";

function App() {
  return (
    <GlobalProvider>
      <Suspense fallback={<Loading />}>
        <Routing />
      </Suspense>
    </GlobalProvider>
  );
}

export default App;
